module.exports = __webpack_public_path__ + "static/media/new_rieltor_bonus_mobile_x2.332036d9.png";